import { Button, Image } from 'react-bootstrap'
import SvgIcons from '../../../components/common/SvgIcons'
import UNVERIFIED from "../../../assets/images/account-needs-to-be-verified.svg";
import { VERIFICATION_MESSAGE } from '../../../constants';
import { Link } from 'react-router-dom';
import { MdVerified } from 'react-icons/md';
import { redirectionRoutes } from '../../../routes/redirectionRoutes';


const PaymentSuccess = () => {
    return (
        <div className='d-flex flex-column h-100'>
            <div className='m-auto text-center col-lg-4'>
                <div className='mb-3 display-4 text-custom-success' aria-label='verification Success'><MdVerified /></div>
                <p className="mb-1 opacity-75 text-uppercase">Payment Done</p>
                <h1 className="fw-semibold mb-4 pb-1 fs-2">{"Payment Success"}</h1>
                <p className='mb-4 opacity-75 pb-1'>
                    Your payment has been successfully done.
                </p>
                <Link to={redirectionRoutes.payment.path} className="btn btn-primary custom-min-width-100">Payment List</Link>
            </div>
        </div>
    )
}

export default PaymentSuccess